<template>
  <div class="blog-wrapper">

    <!-- blogs -->
    <b-row class="blog-list-wrapper">
      <b-card no-body class="col-md-12">
        <b-card-header class="pb-50">
          <h5>
            Filters
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col
                cols="12"
                md="12"
                class="mb-md-0 mb-2"
            >
              <label>Тип</label>
              <v-select
                  v-model="type"
                  :options="typeOptions"
                  class="w-100"
                  :reduce="val => val.value"
                  :clearable="false"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-overlay
          :show="isLoading"
          rounded="sm"
          variant="white"
          opacity="0.85"
          spinner-variant="primary"
          class="w-100"
      >
      <b-table
          ref="refMoviesListTable"
          :items="moviesList"
          responsive
          :fields="tableColumns"
          primary-key="filmId"
          show-empty
          empty-text="No matching records found"
          class="position-relative"
      >
        <!-- Column: Id -->
        <template #cell(id)="data">
          <b-link
              v-if="data.item.db"
              :to="{ name: 'movie-view', params: { id: data.item.db.id }}"
              class="font-weight-bold"
          >
            #{{ data.item.filmId }}
          </b-link>
          <span v-else-if="data.item.filmId">
            #{{ data.item.filmId }}
          </span>
          <span v-else class="text-muted">
            {{ data.item.imdbId }}
          </span>
        </template>

        <!-- Column: Client -->
        <template #cell(movie)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                  size="32"
                  :src="data.item.posterUrlPreview"
                  :text="avatarText(data.item.nameRu)"
                  variant="primary"
              />
            </template>
            <span class="font-weight-bold d-block">
            {{ data.item.nameRu }} ({{ data.item.year }})
          </span>
            <small class="text-muted">{{ data.item.nameEn }}</small>
          </b-media>
        </template>

        <!-- Column: Issued Date -->
        <template #cell(rating)="data">
          <span class="font-weight-bold font-large-1 ml-1" v-if="data.item.db">
            <span
                :class="(data.item.db.rating_kp < 5) ? 'text-danger' : (data.item.db.rating_kp < 7) ? 'text-gray' : 'text-success'"
            >
              {{ ratingFmt(data.item.db.rating_kp) }}
            </span>
          </span>
          <span class="font-weight-bold font-large-1 ml-1" v-else>
            <span
                :class="(data.item.rating < 5) ? 'text-danger' : (data.item.rating < 7) ? 'text-gray' : 'text-success'"
            >
              {{ ratingFmt(data.item.rating) }}
            </span>
          </span>
        </template>

        <!-- Column: Issued Date -->
        <template #cell(votes)="data">
          <span class="text-nowrap mr-1" v-if="data.item.db">
             {{ formatNumber(data.item.db.votes_kp) }}
          </span>
          <span class="text-nowrap mr-1" v-else>
             {{ formatNumber(data.item.ratingVoteCount) }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">

          <div class="text-nowrap">
            <b-button
                v-if="!data.item.db && data.item.filmId"
                variant="success"
                class="btn-icon"
                size="sm"
                @click="addMovie(data.item)"
                :disabled="(disabled===data.item.filmId)"
            >
              <feather-icon icon="UserPlusIcon"/>
            </b-button>
            <b-button
                v-else-if="data.item.db"
                :to="{name: 'movie-view', params: { id: data.item.db.id }}"
                variant="primary"
                class="btn-icon"
                size="sm"
            >
              <feather-icon icon="ArrowRightCircleIcon"/>
            </b-button>
            <b-button
                v-if="data.item.filmId"
                :href="`https://kinopoisk.ru/film/${data.item.filmId}`"
                target="_blank"
                variant="warning"
                class="btn-icon ml-1"
                size="sm"
            >
              <feather-icon icon="CastIcon"/>
            </b-button>
            <b-button
                v-if="data.item.imdbId"
                :href="`https://www.imdb.com/title/${data.item.imdbId}`"
                target="_blank"
                variant="secondary"
                class="btn-icon ml-1"
                size="sm"
            >
              <feather-icon icon="FilmIcon"/>
            </b-button>
          </div>
        </template>
      </b-table>
      </b-overlay>
      <b-col cols="12">
        <!-- pagination -->
        <div class="my-2">
          <b-pagination
              v-model="page"
              per-page="20"
              align="center"
              :total-rows="total"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-col>
    </b-row>

    <!--/ blogs -->

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BLink,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BCardHeader,
  BTable,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import {avatarText, kFormatter, ratingFmt, formatNumber} from '@core/utils/filter'
import store from "@/store";
import {onUnmounted, ref, watch} from "@vue/composition-api";
import useMoviesList from "./useMoviesList";
import movieStoreModule from "@/views/database/movieStoreModule";
import vSelect from "vue-select";
import router from "@/router";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BCardHeader,
    BTable,
    BButton,
    BOverlay,
    vSelect,
  },
  data() {
    return {
      disabled: 0,
    }
  },
  methods: {
    kFormatter,
    addMovie(movie) {
      this.disabled = movie.filmId
      this.$http.post(`/movie`, {kp_id: movie.filmId, 'title_ru': movie.nameRu})
        .then(res => {
          if (res.data.data) {
            this.$set(movie, 'db', res.data.data)
          }
        })
        .finally(() => {
          this.disabled = 0
        })
    },
  },
  setup() {
    const STORE_MODULE_NAME = 'movies'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, movieStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const type = ref('TOP_250_BEST_FILMS')
    const page = ref(1)
    const total = ref(250)
    const isLoading = ref(false)

    const typeOptions = [
      { label: 'Топ 250', value: 'TOP_250_BEST_FILMS' },
      { label: 'Топ 100 популярных', value: 'TOP_100_POPULAR_FILMS' },
      { label: 'Топ ожиданий', value: 'TOP_AWAIT_FILMS' },
      { label: 'Trakt: трендовые фильмы', value: 'TRAKT_TRENDING_MOVIES' },
      { label: 'Trakt: трендовые сериалы', value: 'TRAKT_TRENDING_SHOWS' },
    ]

    // Table Handlers
    const tableColumns = [
      { key: 'id', label: '#', sortable: false },
      { key: 'movie', sortable: false },
      { key: 'rating', sortable: false },
      { key: 'votes', sortable: false },
      { key: 'actions' },
    ]

    const moviesList = ref([])
    const fetchMovies = (...args) => store.dispatch('movies/fetchMoviesTop', ...args)

    const fetchMoviesList = () => {
      isLoading.value = true
      moviesList.value = []
      fetchMovies({
        type: type.value,
        page: page.value,
      })
      .then(response => {
        moviesList.value = response.data
      })
      .finally(() => {
        isLoading.value = false
      })
    }

    fetchMoviesList()

    watch(type, () => {
      if (page.value === 1) {
        fetchMoviesList()
      } else {
        page.value = 1
      }
    })

    watch(page, () => {
      fetchMoviesList()
    })

    const {
      perPage,
      currentPage,
      totalMovies,
      dataMeta,
      perPageOptions,
      searchQuery,
      isSortDirDesc,
      refMovieListTable,
    } = useMoviesList()

    return {
      fetchMovies,
      tableColumns,
      perPage,
      currentPage,
      totalMovies,
      dataMeta,
      perPageOptions,
      searchQuery,
      isSortDirDesc,
      refMovieListTable,
      moviesList,
      typeOptions,
      type,
      page,
      total,
      isLoading,
      avatarText,
      ratingFmt,
      formatNumber,
      fetchMoviesList,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
